import content from "../config/content.json";

function fileToBase64(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = function () {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
}
function downloadFile(file) {
  const fileFormat = file.fileName.split(".").pop();
  const fileLink = document.createElement("a");
  fileLink.href = `data:application/${fileFormat};base64,${file.fileContent}`;
  fileLink.setAttribute("download", file.fileName);
  document.body.appendChild(fileLink);
  fileLink.click();
  fileLink.remove();
}
function downloadExcelFile(response, fileName) {
  const url = window.URL.createObjectURL(new Blob([response]), {
    type: "application/vnd.ms-excel",
  });
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  // deferred a tick: revoking in the same tick as click() can abort the
  // download in Firefox and Safari
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
}
function downloadPDFFile(apiResult, fileName) {
  if (apiResult) {
    const url = window.URL.createObjectURL(new Blob([apiResult]), {
      type: "application/pdf",
    });
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    // deferred a tick: revoking in the same tick as click() can abort the
    // download in Firefox and Safari
    setTimeout(() => window.URL.revokeObjectURL(url), 0);
  }
}
// function getInputContent(pageName, role) {
//   if (content[0][pageName]) {
//     for (var i=0; i<content[0][pageName].length; i++) {
//       if (role == content[0][pageName][i].role) {

//         return content[0][pageName][i];

//       }
//     }
//   }
//   return {};
// }
function getInputContent(pageName, role) {
  if (content[0][pageName]) {
    for (var i = 0; i < content[0][pageName].length; i++) {
      if (content[0][pageName][i].role.includes(role)) {
        return content[0][pageName][i];
      }
    }
  }
  return {};
}
// POR_ItemHierarchy can flag more than one row as the representative item for
// the same category or department, which renders a duplicate tile on the
// equipment browse screens (BE-1062: two "Aerial Work Platforms" tiles). Keep
// the first row per key -- callers sort by itemOrder first, so that is the
// lowest-itemOrder row. Rows with no key are passed through rather than
// collapsed together.
function dedupeBy(items, keyFn) {
  const seen = new Map();
  const kept = [];
  for (const item of items) {
    const key = keyFn(item);
    if (key === null || key === undefined || key === "") {
      kept.push(item);
    } else if (!seen.has(String(key))) {
      seen.set(String(key), item);
      kept.push(item);
    }
  }
  return kept;
}
// BE-1116: rebuilds an alert config's asset selection from its saved values.
// One entry per saved value, in saved order: the first row carrying that
// fleetId, else a placeholder holding the raw value, so a value that no longer
// resolves is still shown and saved back unchanged.
function buildSelectedEquipments(savedValues, rows) {
  const byFleetId = new Map();
  for (const row of rows || []) {
    if (row && row.fleetId && !byFleetId.has(row.fleetId)) byFleetId.set(row.fleetId, row);
  }
  return (savedValues || []).map((value) => byFleetId.get(value) || { fleetId: value, stockKey: value });
}
function dedupeByCategoryNbr(items) {
  return dedupeBy(items, (e) => e.categoryNbr);
}
function dedupeByDepartmentNbr(items) {
  return dedupeBy(items, (e) => e.departmentNbr);
}

export default {
  getInputContent,
  fileToBase64,
  downloadFile,
  downloadExcelFile,
  downloadPDFFile,
  dedupeBy,
  buildSelectedEquipments,
  dedupeByCategoryNbr,
  dedupeByDepartmentNbr,
};
